/* eslint-disable no-unused-vars */
/* global G */
import { curry, isObj } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { disable, enable } from 'lib/sequence/component/state/disabled'
import { empty } from 'lib/util/object'
import sequenceComponentState from 'lib/sequence/component/state'

const {
  get: hasError,
} = sequenceComponentState('error')

/**
 * Returns true only if `object` is either empty or all of its properties as well as those of its
 * nested objects (if any) are `null`.
 *
 * @param {Object} object check target
 * @returns {boolean}      whether all properties are null
 */
const cleared = object => empty(object) || Object.keys(object)
  .every(key => object[key] === null || object[key] === false
    || (isObj(object[key]) && cleared(object[key])))

/**
 * Enables both the `save` and the `clear` buttons.
 *
 * Only to be used from the module's detail action.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const enableButtons = async (module, component, eventOrValue) => {
  const rootComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { detail } = find(rootComponent)
  const { dynamicData: dynamicForm, clear, save } = find(detail)
  const { value = eventOrValue } = eventOrValue?.detail || {}

  enable(save)
  disable(clear, cleared(value) && !hasError(dynamicForm))

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(enableButtons)
